import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { COMPANY } from "../data/products";

export const Footer = () => (
  <footer className="border-t border-border bg-obsidian" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:px-10 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <img src="/logos/sohom-blue-white.png" alt="SOHOM" className="h-9 w-auto" />
        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Architectural Systems</p>
        <p className="mt-5 text-sm leading-relaxed text-slate-400">
          Precision-fabricated uPVC windows &amp; doors in Hyderabad — engineered for Indian climates, finished to European standards.
        </p>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Explore</p>
        <ul className="mt-5 space-y-3 text-sm">
          {[["About Us", "/about"], ["Products", "/products"], ["Gallery", "/gallery"], ["Contact", "/contact"]].map(([label, to]) => (
            <li key={to}>
              <Link to={to} className="text-slate-400 transition-colors hover:text-gold" data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Systems</p>
        <ul className="mt-5 space-y-3 text-sm text-slate-400">
          <li>Casement Doors &amp; Windows</li>
          <li>Tilt &amp; Turn Systems</li>
          <li>Sliding Doors &amp; Windows</li>
          <li>Slide &amp; Fold · Lift &amp; Slide</li>
        </ul>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">Reach Us</p>
        <ul className="mt-5 space-y-4 text-sm text-slate-400">
          <li className="flex items-start gap-3">
            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-gold" data-testid="footer-phone">{COMPANY.phone}</a>
          </li>
          <li className="flex items-start gap-3">
            <Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            <a href={`mailto:${COMPANY.email}`} className="hover:text-gold" data-testid="footer-email">{COMPANY.email}</a>
          </li>
          <li className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            <span data-testid="footer-address">{COMPANY.address}</span>
          </li>
          <li className="flex items-start gap-3">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            <span>{COMPANY.hours}</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border py-6 text-center font-mono text-xs text-slate-600">
      © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
    </div>
  </footer>
);
